module.exports = (s) => INKIVE.C.BASE_URL + s;
